/**
 * A thin wrapper around a SHA-256 hashed string value. No validation rules are applied here, so any string can be wrapped in this class, but it is intended to be used with the output of the `SHA256Hasher.sha256Hash` function.
 *
 * Use this type to make it explicit that a value has already been hashed,
 * so hashed values can be passed through the system without confusing them
 * with raw, unhashed input.
 *
 * @example
 * ```ts
 * import { sha256Hash } from "../utils/SHA256Hasher";
 *
 * const email = "person@example.com";
 * const hashedEmail = await sha256Hash(email);
 *
 * // Pass the wrapped hash value around as SHA256Hash instead of a raw string.
 * someService.send(hashedEmail);
 * ```
 */
export class SHA256Hash {
  value: string = '';

  constructor(value: string) {
    this.value = value;
  }
}
